import { Injectable, EventEmitter, Injector } from "@angular/core";





@Injectable()
export class Utility {

  constructor(private injector: Injector) {

  }
  currencyFormat(value: number, includeDigits: boolean = false) {
    if (value == null || typeof(value) == 'undefined' || isNaN(value)) {
      return '';
    }
    return `${this.numberFormat(value, includeDigits)} kr`;
  }

  numberFormat(value: number, includeDigits: boolean = false) {
    let formattedValue = parseFloat(value.toFixed(2)).toLocaleString('en', { minimumFractionDigits: 2 }).replace(',', ' ');
    return includeDigits ? formattedValue.replace('.', ',') : formattedValue.split('.')[0];
  }

}





